//#region src/extensions/image-extension/utils/get-image-with-link-html.ts
var e = (e, t) => typeof t?.href == "string" ? [
	"a",
	t,
	["img", e]
] : ["img", e];
//#endregion
export { e as getImageWithLinkHtml };
